import { Inject, Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { EUserType, UserInfo } from "../models/userInfo.model";
import { Observable, Subscription } from "rxjs";
import { User } from "../models/user.model";
import { AuthenticatedHttp } from "./http.service";
import { HttpResponseHandlerService } from "./httpResponseHandler.service";
import { AppConstants } from "../app.constants";
import {
  EDateFormat,
  EDatetimeOrder,
  EDecimalSeperator,
  EDigitGroupingSeperator,
  ELanguage,
  ETimeFormat,
  UserSettings
} from "../models/userSettings.model";
import { HttpModel } from "../models/http.model";
import { JwtHelperService } from "@auth0/angular-jwt";
import { catchError, map } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { EFileGroup } from "../models/documentManager/filegroup.enum";
import { L10N_LOCALE, L10nLocale } from "angular-l10n";

@Injectable()
export class UserService {
  userInfos: UserInfo = new UserInfo();
  userSettings: UserSettings = new UserSettings();
  jwtHelper: JwtHelperService = new JwtHelperService();
  userPermissions: string[] = [];

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private authService: AuthService, private authHttp: AuthenticatedHttp, private httpResponseHandlerService: HttpResponseHandlerService) {
    this.authService.$loggedIn.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        if (!this.jwtHelper.isTokenExpired(this.authService.getToken())) {
          const decodedToken = this.authService.getDecodedToken();
          this.userInfos.setUserInfos(decodedToken);
        }
      }
    });
  }

  sendValidationMail(): Observable<boolean> {
    return this.authHttp.post<HttpModel>(AppConstants.USER_MAIL_VALIDATION, [])
      .pipe(
        map((response) => this.httpResponseHandlerService.handlePostResponse(response, true)),
        catchError((error) => this.httpResponseHandlerService.handleError(error))
      );
  }

  setNewPassword(oldPassword: string, newPassword: string, confirmPassword: string): Observable<boolean> {
    return this.authHttp.post<HttpModel>(AppConstants.AUTH_SET_NEW_PASSWORD, {
      oldPassword,
      newPassword,
      confirmPassword
    }, null)
      .pipe(
        map((response) => this.httpResponseHandlerService.handlePostResponse(response, true)),
        catchError((error: any) => this.httpResponseHandlerService.handleError(error, true))
      );
  }

  resetPassword(newPassword: string, confirmPassword: string, jwtToken: string): Observable<boolean> {
    return this.authHttp.post<HttpModel>(AppConstants.AUTH_RESET_PASSWORD, {
      newPassword,
      confirmPassword,
      jwtToken
    }, null)
      .pipe(
        map((response) => this.httpResponseHandlerService.handlePostResponse(response)),
        catchError((error: any) => this.httpResponseHandlerService.handleError(error))
      );
  }
}
